module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/battle//pop-title.png?v=76840d1a";